import React from 'react';

import { useTheme } from '@mui/material';

const TestIconBold = (props) => {
  const theme = useTheme();
  const color = props?.color || theme.palette.common.blueDark;

  return (
    <svg
      width="14"
      height="16"
      viewBox="0 0 14 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      color={color}
    >
      <rect x="0.5" y="1.1665" width="13" height="13.6667" rx="1.5" stroke="currentColor" />
      <path
        d="M2.9418 4.66243L4.43875 3.33301L4.73979 3.70261L3.09095 5.16956C3.04952 5.20968 2.99428 5.22973 2.93904 5.22973C2.88657 5.22973 2.83133 5.20968 2.78714 5.16956L2.08009 4.5421L2.38666 4.16963L2.9418 4.66243Z"
        fill="currentColor"
      />
      <path
        d="M3.95265 6.52478L4.28684 6.87146L3.51075 7.67656L4.2896 8.48167L3.95542 8.82835L3.17933 8.02325L2.40324 8.82835L2.06905 8.48167L2.84514 7.67656L2.06629 6.87146L2.40047 6.52478L3.17656 7.32988L3.95265 6.52478Z"
        fill="currentColor"
      />
      <path d="M12.23 4.00918H5.53521V4.49912H12.23V4.00918Z" fill="currentColor" />
      <path d="M12.23 7.43303H5.53521V7.92297H12.23V7.43303Z" fill="currentColor" />
      <path d="M12.23 10.854H5.53521V11.3439H12.23V10.854Z" fill="currentColor" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.12113 9.87699H2.23476C2.10495 9.87699 2 9.98587 2 10.1205V12.0774C2 12.2121 2.10495 12.321 2.23476 12.321H4.12113C4.25094 12.321 4.35589 12.2121 4.35589 12.0774V10.1205C4.35589 9.98587 4.25094 9.87699 4.12113 9.87699ZM2.46952 11.8339H3.88361V10.3669H2.46952V11.8339Z"
        fill="currentColor"
      />
      <path
        d="M2.9418 4.66243L4.43875 3.33301L4.73979 3.70261L3.09095 5.16956C3.04952 5.20968 2.99428 5.22973 2.93904 5.22973C2.88657 5.22973 2.83133 5.20968 2.78714 5.16956L2.08009 4.5421L2.38666 4.16963L2.9418 4.66243Z"
        stroke="currentColor"
        strokeWidth="0.5"
      />
      <path
        d="M3.95265 6.52478L4.28684 6.87146L3.51075 7.67656L4.2896 8.48167L3.95542 8.82835L3.17933 8.02325L2.40324 8.82835L2.06905 8.48167L2.84514 7.67656L2.06629 6.87146L2.40047 6.52478L3.17656 7.32988L3.95265 6.52478Z"
        stroke="currentColor"
        strokeWidth="0.5"
      />
      <path
        d="M12.23 4.00918H5.53521V4.49912H12.23V4.00918Z"
        stroke="currentColor"
        strokeWidth="0.5"
      />
      <path
        d="M12.23 7.43303H5.53521V7.92297H12.23V7.43303Z"
        stroke="currentColor"
        strokeWidth="0.5"
      />
      <path
        d="M12.23 10.854H5.53521V11.3439H12.23V10.854Z"
        stroke="currentColor"
        strokeWidth="0.5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.12113 9.87699H2.23476C2.10495 9.87699 2 9.98587 2 10.1205V12.0774C2 12.2121 2.10495 12.321 2.23476 12.321H4.12113C4.25094 12.321 4.35589 12.2121 4.35589 12.0774V10.1205C4.35589 9.98587 4.25094 9.87699 4.12113 9.87699ZM2.46952 11.8339H3.88361V10.3669H2.46952V11.8339Z"
        stroke="currentColor"
        strokeWidth="0.5"
      />
    </svg>
  );
};

export default TestIconBold;
